// helpers/deriveQueueStatus.js
//
// Maps a Kanban column's `key` (or `_id`/`name`) to the worker pipeline's
// queueStatus enum so a drag-drop can persist the right lifecycle state and
// fire the matching outbox event.
//
// Extracted from KanbanBoard so the mapping can be unit-tested in isolation.
//
// THE BUG THIS FIXES: dragging a post from Approved back to "Awaiting
// approval" did nothing — the card snapped straight back to Approved and the
// post was still published. The old mapping had no branch for the
// awaiting-approval column, so it returned `undefined`; the drag handler then
// sent only `status` (the column id) and NO queueStatus. The post kept
// queueStatus='approved', so:
//   1. bucketForItem (which reads queueStatus first) re-bucketed the card
//      into the Approved column on the next render, and
//   2. duePostScheduler — which sweeps queueStatus in ['scheduled','approved']
//      — still published it.
// Detecting the awaiting-approval column and returning 'awaiting-approval'
// makes the un-approve actually reset the post's lifecycle state.
//
// Order matters: the awaiting-approval check MUST come before the 'approve'
// check, because the column key/name ('awaiting-approval' / 'Awaiting
// approval') contains the 'approval' substring and we never want an
// un-approve to resolve back to 'approved'.
//
// Sources of truth:
//   - Post.queueStatus enum   back/models/post.js
//   - Idea.queueStatus enum   back/models/idea.js  (also has 'awaiting-approval')
//   - POST_KANBAN_STATUSES    frontend/src/constants/kanbanStatuses.js
// CommonJS (like helpers/kanbanBucket.js) so the mapping runs under bare
// `npx jest` as well as webpack's ES-import interop in KanbanBoard.
function deriveQueueStatus(milestoneKey = '') {
  const k = String(milestoneKey).toLowerCase();
  if (/awaiting|await/.test(k)) return 'awaiting-approval';
  if (/approve/.test(k)) return 'approved';
  if (/reject|decline/.test(k)) return 'rejected';
  if (/pending|draft/.test(k)) return 'pending';
  if (/posted|publish/.test(k)) return 'posted';
  // Dragging a card onto the hidden Archived shelf shelves it.
  if (/archiv/.test(k)) return 'archived';
  return undefined;
}

module.exports = { deriveQueueStatus };
